import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import prefrence from "../../assets/images/rsicons/prefrence.png"

//import Lead from "./Lead";
import ClientLink from "./client-link";
import { getClientDetail, updateClientProfile, updateClientPrimaryProfile} from "../../store/clients/actions"
import Switch from "react-switch"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import {  isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import SaveButton from "components/buttons/save";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  Collapse
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios"
import ClientProfileMenu from "./menu/client-profile-menu";
import ClientProfileBreadcrumbs from "components/Common/ClientProfileBreadcrumb";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import LineBreadcrumbs from "components/Common/LineBreadcrumb";
import SafeField from "helpers/SafeField";
import { hasPermission } from "helpers/checkPermission";
class ClientProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rows: [],
      rows1: [],
      clientTypes:[],
      titles:[],
      importantdate:'',
      sources:[],
      reports: [
        { title: "Upcoming Closings", iconClass: "bx-copy-alt", description: "14" },
        {
          title: "Upcoming appointments",
          iconClass: "bx-archive-in",
          description: "6",
        },
        {
          title: "Active Clients ",
          iconClass: "bx-purchase-tag-alt",
          description: "5",
        },
        {
          title: "Messages Received",
          iconClass: "bx-purchase-tag-alt",
          description: "5",
        },
        {
          title: "Investment interest",
          iconClass: "bx-purchase-tag-alt",
          description: "5",
        },
      ],
   
    }
  }

  

componentDidMount() {
  const { match: { params }, onGetClientDetail} = this.props;
  onGetClientDetail(params.clientId); 
  
   const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
  
    const str = 'Bearer ' + token;
    
      axios.get('https://rscoreapi.azurewebsites.net/api/FieldValue/allbyname', {
          params: {
            fieldName: 'Agent:Title',
          }, headers: { Authorization: str }
        })
          .then(res => {
            const titles = res.data;
            this.setState({ titles });
          })
         
}
 handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };
  render() {
    const { clietDetail, loading, onUpdateClientProfile, isResponsive } = this.props;
    const Offsymbol = () => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "#fff",
            paddingRight: 2
          }}
        >
          {" "}
          Inactive
        </div>
      )
    }

    const OnSymbol = props => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "#fff",
            paddingRight: 2
          }}
        >
          {" "}
          Active
        </div>
      )
    }

    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
        

            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
               <Row className="project-header">
                            <Col sm='7'>
                         <LineBreadcrumbs
                          title={this.props.t("Clients")}
                          breadcrumbItem={this.props.t(  " Dashboard")}
                        />
                        </Col>
                        <Col sm="4" className="">
                            <h2 className="mb-0">{this.props.t( clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                <span>{clietDetail?.userLogin?.userName}</span>
                            </Col>
                        </Row>

            <ClientProfileMenu isResponsive={isResponsive} />
            <Row>
              
              
              <Col xl="12">
            
              <Card className="border-full">
                          <CardBody>

                          <Formik
                        enableReinitialize={true}
                        initialValues={{
                         
                            id: clietDetail?.id,
                            clientId: clietDetail?.clientId,
                            agentId: clietDetail?.agentId,
                            userLogin: clietDetail?.userLogin?.userName,
                            title: clietDetail?.title,
                            firstName: clietDetail?.firstName,
                            lastName: clietDetail?.lastName,
                            prefferedEmail: clietDetail?.prefferedEmail,
                            clientStatusId: clietDetail?.clientStatusId,
                            clientPropertyTypeId: clietDetail?.clientPropertyTypeId,
                            clientTypeId: clietDetail?.clientTypeId,
                            clientSourceId: clietDetail?.clientSourceId,
                            primaryContactId: clietDetail?.primaryContactId,
                            secondaryContactId: clietDetail?.secondaryContactId,
                            addressId: clietDetail?.addressId,
                            isActive: clietDetail?.isActive,
                            referedById: clietDetail?.referedById,
                            referedBy: clietDetail?.referedBy,
                            referralCode: clietDetail?.referralCode,
                            howOffenClient: clietDetail?.howOffenClient,
                            notes: clietDetail?.notes,
                            fullAddress: clietDetail?.clientAddress?.fullAddress,
                            addressLine1: clietDetail?.clientAddress?.addressLine1,
                            addressLine2: clietDetail?.clientAddress?.addressLine2,
                            nearestIntersection: clietDetail?.clientAddress?.nearestIntersection,
                            city: clietDetail?.clientAddress?.city,
                            province: clietDetail?.clientAddress?.province,
                            postal: clietDetail?.clientAddress?.postal,
                            country: clietDetail?.clientAddress?.country,
                            longitude: clietDetail?.clientAddress?.longitude,
                            latitude: clietDetail?.clientAddress?.latitude,
                            contactFName: clietDetail?.primaryContact?.contactFName,
                            contactLName: clietDetail?.primaryContact?.contactLName,  
                            petName: clietDetail?.primaryContact?.petName,
                           
                            phone: clietDetail?.primaryContact?.cContact?.phone,
                            phoneExt: clietDetail?.primaryContact?.cContact?.phoneExt,
                            email: clietDetail?.primaryContact?.cContact?.email,
                            mobile: clietDetail?.primaryContact?.cContact?.mobile,
                            office: clietDetail?.primaryContact?.cContact?.office,
                            fax: clietDetail?.primaryContact?.cContact?.fax,
                            primaryTitle: clietDetail?.primaryContact?.title,
                            organization: clietDetail?.primaryContact?.organization,
                            jobTitle: clietDetail?.primaryContact?.jobTitle,
                            industry: clietDetail?.primaryContact?.industry,
                            
            
                        }}
                        validationSchema={Yup.object().shape({
                          //primaryTitle: Yup.string().required("This is Required"),
                          contactFName :Yup.string().max(100,"100 Characters are allowed").required("This is Required"),
                          contactLName : Yup.string().max(100,"100 Characters are allowed"),
                          mobile : Yup.string().required("This is Required"),
                          //phone : Yup.string().min(10,"10 Digits are allowed").max(10,"10 Digits are allowed"),
                          email : Yup.string().max(100,"100 Characters are allowed").email().required("This is Required"),
                          //office : Yup.string().min(10,"10 Digits are allowed").max(10,"10 Digits are allowed"),
                          //phoneExt : Yup.string().min(3,"Min. 3 Digts are Required").max(6,"Max. 6 Digts are Required"),

                        
                        })}

                        onSubmit={values => {
                          //
                          const updatePrimary = {
                            id: parseInt(values.id),
                            clientId: values.clientId,
                            agentId: parseInt(values.agentId),
                            userLogin: values?.userLogin,
                            title: values.title,
                            firstName: values.firstName,
                            lastName: values.lastName,
                            prefferedEmail: values.prefferedEmail,
                            clientStatusId: parseInt(values.clientStatusId),
                            clientPropertyTypeId: parseInt(values.clientPropertyTypeId),
                            clientTypeId: parseInt(values.clientTypeId),
                            clientSourceId: parseInt(values.clientSourceId),
                            primaryContactId: parseInt(values.primaryContactId),
                            secondaryContactId: parseInt(values.secondaryContactId),
                            addressId: parseInt(values.addressId),
                            isActive: values.isActive,
                            referedById: parseInt(values.referedById),
                            referedBy: values.referedBy,
                            referralCode: values.referralCode,
                            howOffenClient: values.howOffenClient,
                            notes:values.notes,
                            fullAddress: values.fullAddress,
                            addressLine1: values.addressLine1,
                            addressLine2: values.addressLine2,
                            nearestIntersection: values.nearestIntersection,
                            city: values.city,
                            province: values.province,
                            postal: values.postal,
                            country: values.country,
                            longitude: values.longitude,
                            latitude: values.latitude,
                            contactFName: values.contactFName,
                            contactLName: values.contactLName,  
                            petName: values.petName,
                           
                            phone: values.phone,
                            phoneExt: values.phoneExt,
                            email: values.email,
                            mobile: values.mobile,
                            office:values.office,
                            fax: values.fax,
                            primaryTitle: values.primaryTitle,
                            organization: values.organization,
                            jobTitle: values.jobTitle,
                            industry: values.industry
                        
 
                        };
                            onUpdateClientProfile(updatePrimary);
                            //clietDetail.primaryContact = updatePrimary;
                            //
                        
                          
                        }}
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                          className="needs-validation"
                        >
                          {/* <h5 className="card-title">Primary Contact Details</h5> */}
              
              <Row>
                   {/* <Col sm="1">
                   <FormGroup className="mb-3">
                       <Label htmlFor="primaryTitle">
                         {this.props.t("Title*")}
                       </Label>
                       <SafeField as="select" name="primaryTitle" 
                       className={
                         "form-control" +
                         (errors.primaryTitle && touched.primaryTitle
                           ? " is-invalid"
                           : "")
                       }
                       
                       onChange={handleChange}>
                           <option value="">Select</option>
                               {
                                 this.state.titles
                                   .map(title =>
                                     <option key={title.id} value={title.fieldValueName}>{title.fieldValueName}</option>
                                   )
                               }
                       </SafeField>
                       <ErrorMessage
                         name="primaryTitle"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>
                   </Col> */}

                   <Col sm="3">
                   <FormGroup className="mb-3">
                       <Label htmlFor="contactFName">
                         {this.props.t("First Name*")}
                       </Label>
                       <SafeField
                         name="contactFName"
                         onChange={handleChange}  
                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.contactFName && touched.contactFName
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="contactFName"
                       />
                        <ErrorMessage
                         name="contactFName"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>
                   </Col>
                   <Col sm="3">
                   <FormGroup className="mb-3">
                       <Label htmlFor="contactLName">
                         {this.props.t("Last Name")}
                       </Label>
                       <SafeField
                         name="contactLName"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.contactLName && touched.contactLName
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="contactLName"
                       />
                        <ErrorMessage
                         name="contactLName"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>
                   </Col>    
                     

                   <Col sm="3">
                    <PhoneInputField
                        label="Mobile"
                        name="mobile"
                        value={values.mobile}
                        setFieldValue={setFieldValue}
                        error={errors.mobile}
                        touched={touched.mobile}
                        country="ca"
                        required={true}
                      />
               
                   </Col>
             
               <Col sm="3">
                 <PhoneInputField
                        label="Phone"
                        name="phone"
                        value={values.phone}
                        setFieldValue={setFieldValue}
                        error={errors.phone}
                        touched={touched.phone}
                        country="ca"
                        required={false}
                      />
                   
                   </Col>     
                       <Col sm="3">
                       <FormGroup className="mb-3">
                       <Label htmlFor="email">
                         {this.props.t("Email*")}
                       </Label>
                       <SafeField
                         name="email"
                         onChange={handleChange}                            
                         type="text"
                        
                         className={
                           "form-control" +
                           (errors.email && touched.email
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="email"
                       />
                        <ErrorMessage
                         name="email"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>

                       </Col>
                       <Col sm="3">
                       <FormGroup className="mb-3">
                       <Label htmlFor="organization">
                         {this.props.t("Company Name")}
                       </Label>
                       <SafeField
                         name="organization"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.organization && touched.organization
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="organization"
                       />
                        <ErrorMessage
                         name="organization"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>

                       </Col>

                       <Col sm="3">
                       <FormGroup className="mb-3">
                       <Label htmlFor="jobTitle">
                         {this.props.t("Job Title")}
                       </Label>
                       <SafeField
                         name="jobTitle"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.jobTitle && touched.jobTitle
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="jobTitle"
                       />
                        <ErrorMessage
                         name="jobTitle"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>

                       </Col>

                       <Col sm="2">
                        <PhoneInputField
                        label="Office Phone"
                        name="office"
                        value={values.office}
                        setFieldValue={setFieldValue}
                        error={errors.office}
                        touched={touched.office}
                        country="ca"
                        required={false}
                      />
                

                       </Col>
                       <Col sm="1">
                       <FormGroup className="mb-3">
                       <Label htmlFor="phoneExt">
                         {this.props.t("Ext")}
                       </Label>
                       <SafeField
                         name="phoneExt"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.phoneExt && touched.phoneExt
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="phoneExt"
                       />
                        <ErrorMessage
                         name="phoneExt"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>

                       </Col>

                       <Col sm="3">
                       <FormGroup className="mb-3">
                       <Label htmlFor="industry">
                         {this.props.t("Industry")}
                       </Label>
                       <SafeField
                         name="industry"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.industry && touched.industry
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="industry"
                       />
                        <ErrorMessage
                         name="industry"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>

                       </Col>
                         <Col md="9">
                                         <FormGroup className="mb-3">
                                           <Label htmlFor="streetName">
                                             {this.props.t("Address")}
                                           </Label>
                       
                       
                                           <PlacesAutocomplete
                                             value={values.fullAddress}
                                             onChange={(value) => setFieldValue('fullAddress', value)}
                                             onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                           >
                                             {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                               <div>
                                                 <input
                                                   {...getInputProps({
                                                     placeholder: 'Enter Address...',
                                                     className: 'form-control',
                       
                                                   })}
                                                 />
                                                 <div className="">
                                                   {loading ? <div>Loading...</div> : null}
                       
                                                   {suggestions.map((suggestion, i) => {
                                                     const className = suggestion.active
                                                       ? 'suggestion-item--active'
                                                       : 'suggestion-item';
                                                     const style = suggestion.active
                                                       ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                       : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
                       
                                                     return (
                                                       <div
                                                         key={i}
                                                         {...getSuggestionItemProps(suggestion, {
                                                           style,
                                                         })}
                                                       >
                                                         {suggestion.description}
                                                       </div>
                                                     );
                                                   })}
                                                 </div>
                                               </div>
                                             )}
                                           </PlacesAutocomplete>
                       
                                         </FormGroup>
                                       </Col>
                       <div className="clearfix">
                        
                        
                          {hasPermission("RealtorClients", "Edit") && ( <SaveButton>Save</SaveButton> )}</div>

                       </Row>
                          </Form>
                           )}
                           </Formik>
                          </CardBody>
                        </Card>


            
            </Col>
            
            </Row>
            </Col>
            </Row>
           
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientProfile.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  match: PropTypes.object,
  onGetClientDetail:PropTypes.func,
  clietDetail: PropTypes.object,
  addClientImportantDate:PropTypes.func,
  addClientChild:PropTypes.func,
  onGetClientImportantDate:PropTypes.func,
  onGetClientChild:PropTypes.func,
  importantdates:PropTypes.array,
  childs:PropTypes.array,
  onDeleteImportantDate:PropTypes.func,
  loading:PropTypes.object,
  onUpdateClientProfile:PropTypes.func,
  isResponsive:PropTypes.object

}
const mapStateToProps = ({ Clients }) => (
  {
    loading: Clients.loading,
    clietDetail: Clients.clietDetail,
    importantdates:Clients.importantdates,
    childs:Clients.childs
    

  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  onUpdateClientProfile: (data) => dispatch(updateClientPrimaryProfile(data))

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientProfile))
